export default class memberDataClass
{
    profile_picture = null;

    profile_updated = false;

    relationships = [];

    addresses = [];

    industries = [];

    missions = [];

    tags = [];

    relationship_name= {value:'Husband,Wife',name:'Husband -> Wife'};

    first_name=null;

    middle_name=null;

    last_name=null;

    gender='Male';

    marital_status = null;

    occupation= null;

    email=null;

    is_member = false;

    mobile_number=null;

    whatsapp_number=null;

    dob=null;
}